// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8586f89e","455":"9a322110","977":"d5aea547"}[chunkId] + ".chunk.js";
};